import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_DEVICE_DETAILS } from './url-constants';

type DeleteStarfishGatewayEndpointSpecification = ApiEndpointSpecification;
export const DeleteStarfishGatewayEndpointSpecification: DeleteStarfishGatewayEndpointSpecification = {
    url: STARFISH_DEVICE_DETAILS,
    method: HttpMethod.DELETE,
    requestParamsSchemaName: 'DeleteStarfishGatewayRequestParams',
    requestBodySchemaName: 'DeleteStarfishGatewayRequestBody',
    okResponseSchemaName: 'DeleteStarfishGatewayOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3.0
};

export const invokeDeleteStarfishGateway = Helpers.makeApiRequestFn<
    Types.DeleteStarfishGatewayRequestParams,
    Types.DeleteStarfishGatewayRequestBody,
    Types.DeleteStarfishGatewayOkResponse
>(DeleteStarfishGatewayEndpointSpecification);
